import {
  CAREER_POPUP_DATA,
  CAREER_POPUP_DATA_FAIL,
  CAREER_POPUP_DATA_SUCCESS,
  HIDE_CAREER_POPUP_DATA,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS,
  UPDATE_CAREER_POPUP_DATA,
  UPDATE_CAREER_POPUP_DATA_FAIL,
  UPDATE_CAREER_POPUP_DATA_SUCCESS,
} from "./actionTypes";

export const getCareerPageData = () => {
  return {
    type: CAREER_POPUP_DATA,
    payload: {},
  };
};

export const getCareerPageDataSuccess = (configData) => {
  return {
    type: CAREER_POPUP_DATA_SUCCESS,
    payload: { configData },
  };
};

export const getCareerPageDataFail = (configData) => {
  return {
    type: CAREER_POPUP_DATA_FAIL,
    payload: { configData },
  };
};

export const updateCareerPageUrl = (url) => {
  return {
    type: UPDATE_CAREER_POPUP_DATA,
    payload: { url },
  };
};

export const updateCareerPageUrlSuccess = (configData) => {
  return {
    type: UPDATE_CAREER_POPUP_DATA_SUCCESS,
    payload: { configData },
  };
};

export const updateCareerPageUrlFail = (configData) => {
  return {
    type: UPDATE_CAREER_POPUP_DATA_FAIL,
    payload: { configData },
  };
};
export const hideCareerPopUp = () => {
    return {
      type: HIDE_CAREER_POPUP_DATA,
      payload: {  },
    };
  };

  // career page integration actions
  export const updateCareerPageLink= (data) => {
    return {
      type: UPDATE_CAREER_PAGE_INTEGRATION_LINK,
      payload: { data },
    };
  };
 
  export const updateCareerPageLinkSuccess = (success) => {
    return {
      type: UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS,
      payload: { success },
    };
  };

  export const updateCareerPageLinkFailed = (error) => {
    return {
      type: UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL,
      payload: { error },
    };
  };
  

